/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_notStarted as NotStartedCourse } from './__generated__/getUpcomingCourseStatesQuery';

type Props = {
  upcomingCourses: NotStartedCourse[];
  supportEmailAddress?: string;
};

const UpcomingCoursesDescription: React.FunctionComponent<Props> = ({ upcomingCourses, supportEmailAddress }) => {
  const hasMultipleUpcomingCourses = upcomingCourses.length > 1;
  const supportLink = supportEmailAddress ? (
    <Link href={`mailto:${supportEmailAddress}`}>{supportEmailAddress}</Link>
  ) : (
    _t('your universify')
  );
  const cardDescription = hasMultipleUpcomingCourses ? (
    <FormattedMessage
      message={_t(
        "Enrollment for multiple courses will open soon. You'll get an email notification when they do. Contact {supportEmail} for more info."
      )}
      supportEmail={supportLink}
    />
  ) : (
    <FormattedMessage
      message={_t(
        "Enrollment for {courseName} will open soon. You'll get an email notification when it does. Contact {supportEmail} for more info."
      )}
      courseName={upcomingCourses[0].name}
      supportEmail={supportLink}
    />
  );

  return (
    <React.Fragment>
      <Typography2
        component="p"
        variant="bodyPrimary"
        css={css`
          padding-bottom: 1rem;
        `}
      >
        {cardDescription}
      </Typography2>
    </React.Fragment>
  );
};

export default UpcomingCoursesDescription;
